export class BlogCategory {
  id: number = 0;
  name: string = "";
  constructor() {
    this.id = 0;
    this.name = "";
  }
  parseJson(retCat: { id: number; attributes: { [key: string]: any } }) {
    this.id = retCat.id;
    this.name = retCat.attributes.Name;
  }
}
